var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "h3",
    { staticClass: "grey-color mb-3 main_text font-weight-bold" },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }